import React from 'react';

const ChevronRight = (props) => (
  <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M0.586031 12.293L2.00003 13.707L8.70703 7.00003L2.00003 0.29303L0.586031 1.70703L5.87903 7.00003L0.586031 12.293Z" fill={props.fill}/>
  </svg>
);
export default ChevronRight;
